// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import { ExportOption } from 'ChartApp/ts/services/export-service/enum';
export const MAX_DATES = 6; // Maximum number of dates used for different series simultaneously
export const YIELD_CURVE_EXPORT_OPTIONS = {
    title: {
        label: 'Export',
        icon: 'icon-export',
    },
    list: [
        {
            type: 'option',
            label: 'Export Data',
            value: ExportOption.export,
            icon: 'icon-csv',
        },
        {
            type: 'option',
            label: 'Download Image',
            value: ExportOption.download,
            icon: 'icon-download',
        },
        {
            type: 'option',
            label: 'Download PDF',
            value: ExportOption.pdf,
            icon: 'icon-print',
        },
    ],
};
// Mapping of treasury yield terms to x-axis units for spacing different treasury yield terms based on their time period.
// Space values as a root of the term length to provide time-based scaling while providing enough space for short terms.
// This should be kept in sync with the terms used in the chart generator frontend.
export const UNITS_PER_TERM = {
    // Calculated values are the result of months^0.75 + 1
    '1M': 2,
    '3M': 3.28,
    '6M': 4.83,
    '1Y': 7.45,
    '2Y': 11.84,
    '5Y': 22.56,
    '7Y': 28.75,
    '10Y': 37.26,
    '20Y': 61.98,
    '30Y': 83.65,
};
export const TERM_PER_UNITS = Object.fromEntries(Object.entries(UNITS_PER_TERM).map(([term, units]) => [units, term]));
export const YIELD_CURVE_UNITS = Object.values(UNITS_PER_TERM);
export const YIELD_CURVE_TERMS = Object.keys(UNITS_PER_TERM);
export const HIGHCHARTS_YIELD_CURVE_DEFAULT_OPTIONS = {
    chart: {
        type: 'spline',
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
        zooming: { mouseWheel: false },
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    enabled: true,
                },
            },
        },
    },
    title: {
        text: '',
    },
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    exporting: {
        enabled: false,
    },
    xAxis: {
        type: 'linear',
        lineColor: '#e5e5e5',
        tickColor: '#e5e5e5',
        tickPositions: YIELD_CURVE_UNITS,
        title: {
            text: '',
        },
        gridLineWidth: 1,
        labels: {
            // This file is automatically copied to the chart generator project. There, this formatter does nothing,
            // because the chart options are passed through JSON.stringify in order to be passed from the express server
            // backend to the rendering frontend. JSON.stringify omits functions. In the chart generator project, this
            // functionality is instead replicated in the yield curve service.
            formatter() {
                // Here in the formatter we can't access the series custom data which contains the term string.
                // Calculate the term string based on the x-axis units assigned for the term.
                return Number(this.value) in TERM_PER_UNITS ? TERM_PER_UNITS[Number(this.value)] : '';
            },
            style: {
                color: '#666',
            },
        },
    },
    noData: {
        style: {
            fontSize: '30px',
        },
    },
    yAxis: {
        lineColor: '#e5e5e5',
        type: 'percent',
        labels: {
            format: '{value}%',
            style: {
                color: '#666',
            },
        },
        title: {
            text: '',
        },
    },
    series: [],
    colors: ['#6933c9', '#ffa870', '#568cd8', '#9bcc4f', '#dd1baa', '#bf9375'], // Colors should match .bullet-x css
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 1024, // Mobile + Tablet devices
                },
                chartOptions: {
                    xAxis: {
                        labels: {
                            staggerLines: 2,
                        },
                    },
                },
            },
        ],
    },
};
export const HIGHCHARTS_YIELD_CURVE_PRESENTATION_OPTIONS = _.merge({}, HIGHCHARTS_YIELD_CURVE_DEFAULT_OPTIONS, {
    chart: {
        animation: false,
        events: {
            render: () => {
                // @ts-ignore
                window.ycharts.chartLoadedResolver();
            },
        },
    },
    plotOptions: {
        series: {
            animation: false,
        },
        heatmap: {
            dataLabels: {
                animation: { defer: 0 },
            },
        },
    },
});
